import React, { PureComponent } from 'react'
import { Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import RoleModalPage from '../../../containers/masters/role/RoleModalPage'
import IDocCarPagination from '../../commons/iDocCarPagination'
import { Field, reduxForm } from 'redux-form'
import InputSelect from '../../commons/form/InputSelect'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class RoleAdmin extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        searchSection: null,
        searchPermission: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchRoleList(this.props.filter)
    this.props.actions.fetchSectionCombo()
    this.props.actions.fetchPermissionCombo()
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    const filter = { ...this.props.filter, ...this.state.filter }
    switch (this.props.filter.orderBy) {
      case '':
        this.props.actions.fetchRoleList({ ...filter, orderBy: `+${field}` })
        break
      case `+${field}`:
        this.props.actions.fetchRoleList({ ...filter, orderBy: `-${field}` })
        break
      case `-${field}`:
      default:
        this.props.actions.fetchRoleList({ ...filter, orderBy: '' })
        break
    }
  }

  handleSectionChange (searchSection) {
    if (this.state.filter.searchSection !== searchSection) {
      this.setState({ filter: { ...this.state.filter, searchSection: searchSection } })
    }
  }

  handlePermissionChange (searchPermission) {
    if (this.state.filter.searchPermission !== searchPermission) {
      this.setState({ filter: { ...this.state.filter, searchPermission: searchPermission } })
    }
  }

  searchRoles () {
    this.props.actions.fetchRoleList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  resetFilters () {
    this.setState({
      filter: {
        searchSection: null,
        searchPermission: null
      }
    }, () => { this.searchRoles() })
  }

  render () {
    const {
      t, roleList, pagesCount, filter, rolesCount,
      filter: { page },
      combos: { permissionCombo, sectionCombo },
      actions: { openEditRoleModal, openAddRoleModal, fetchRoleList, deleteRole, cloneRole }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'adminRolesPage' })
    const tKey = 'ADMIN.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const copyTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}COPY`)}</Tooltip>)

    const hasFilters = ((this.state.filter.searchSection && this.state.filter.searchSection.length > 0) || (this.state.filter.searchPermission && this.state.filter.searchPermission.length > 0))

    return (
      <div id='roleAdmin' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => openAddRoleModal()}>
              <i className='iDocIcon-add-plus'></i> {t('MASTERS.ADD')} {t(`${secMapMasters.title}`)}
            </Button>
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.searchSection"
                controlLabel={t(`${tKey}ROLES_PAGE.SEARCH_SECTIONS`)}
                placeholder={t(`${tKey}ROLES_PAGE.SEARCH_SECTIONS`)}
                multi={true}
                valueKey="id"
                labelKey="value"
                options={sectionCombo}
                onInputChange={(value) => this.handleSectionChange(value)}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.searchPermission"
                controlLabel={t(`${tKey}ROLES_PAGE.SEARCH_PERMISSIONS`)}
                placeholder={t(`${tKey}ROLES_PAGE.SEARCH_PERMISSIONS`)}
                multi={true}
                valueKey="id"
                labelKey="value"
                options={permissionCombo}
                onInputChange={(value) => this.handlePermissionChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.searchRoles()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              {(roleList.length !== 0) && (
                <Table className="editable-table" hover responsive>
                  <thead>
                    <tr>
                      <th onClick={() => { this.changeOrder('roleId') }}>
                        {t(`${tKey}ID`)}&nbsp;
                        <i className={this.getSortIcon('roleId')} />
                      </th>
                      <th onClick={() => { this.changeOrder('roleName') }}>
                        {t(`${tKey}NAME`)}&nbsp;
                        <i className={this.getSortIcon('roleName')} />
                      </th>
                      <th onClick={() => { this.changeOrder('roleDescription') }}>
                        {t(`${tKey}DESCRIPTION`)}&nbsp;
                        <i className={this.getSortIcon('roleDescription')} />
                      </th>
                      <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {roleList && roleList.map((role, idx) => {
                      return (
                        <tr key={idx} className={(role.isDeleted ? 'is-deleted' : '')}>
                          <td>{role.roleId}</td>
                          <td>{role.name}</td>
                          <td>{role.description}</td>
                          <td className='actions'>
                            {!role.isDeleted && (
                              <div>
                                <OverlayTrigger placement="left" overlay={editTooltip}>
                                  <a className='_Btn accept stk o-icn ' onClick={() => openEditRoleModal(role.roleId)}>
                                    <i className="iDocIcon-edit" />
                                  </a>
                                </OverlayTrigger>
                                <OverlayTrigger placement="left" overlay={copyTooltip}>
                                  <a className='_Btn accept stk o-icn ' onClick={() => cloneRole(role.roleId, { ...filter, ...this.state.filter })}>
                                    <i className="iDocIcon-copy-clone"/>
                                  </a>
                                </OverlayTrigger>
                                <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                  <a className='_Btn cancel stk o-icn ' onClick={() => deleteRole(role.roleId, { ...filter, ...this.state.filter })}>
                                    <i className="iDocIcon-delete-forever" />
                                  </a>
                                </OverlayTrigger>
                              </div>
                            )}
                          </td>
                        </tr>)
                    })
                    }

                  </tbody>
                </Table>
              )}
              {(roleList === null || roleList === undefined || roleList.length === 0) && (
                <p className="no_results" >{t(`${tKey}ROLES_PAGE.RESULTS_NOT_FOUND`)}</p>
              )}
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows= {rolesCount}
                    onSelectAction={(value) => fetchRoleList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <RoleModalPage/>
      </div>
    )
  }
}

export default reduxForm({
  form: 'roleAdmin'
})(RoleAdmin)
